import { Enumeration } from '../../utils/AppEnum';

export class AWSEnvironment extends Enumeration<AWSEnvironment> {

    public static Development = new AWSEnvironment('DEV', 1);

    public static Testing = new AWSEnvironment('TST', 2);

    public static Production = new AWSEnvironment('PRD', 3);

    public static PoC = new AWSEnvironment('POC', 4);
}
